import store from "@/store";

export function ProcessUserData() {
    const userGetterValue = store.getters["auth/GET_USER"];
    if (!userGetterValue) {
        return null;
    }

    const u = JSON.parse(userGetterValue);

    // Sanctum token (NO JWT)
    const token = localStorage.getItem("authToken") || "";

    // Ya no decodificamos JWT
    const decoded = null;

    let sucu: any = null;

    if (u.ultcodcli && u.tipo == "G") {
        const detalles = Array.isArray(u.detalles) ? u.detalles : [];
        sucu = detalles.filter((item: any) => item.codcli == u.ultcodcli)[0] || null;
    }

    if (u.tipo == "P") {
        sucu = {
            nomcli: u?.detalles?.codsede,
            codmone: u?.detalles?.CodMoneda,
        };
    }

    u.id_tipo = u.tipo;
    u.tipo = showType(u.tipo);

    if (u.created_at) {
        u.created_at = formatDate(u.created_at);
    }

    const dataUser = {
        ...u,
        ...(sucu || {}),
        token,
        decoded,
    };

    return dataUser;
}

function showType(type: string) {
    switch (type) {
        case "A":
            return "ADMINISTRADOR";
        case "G":
            return "GRUPO";
        case "P":
            return "PROVEEDOR";
        default:
            return type;
    }
}

function formatDate(date: string) {
    const parsedDate = new Date(date);

    const day = parsedDate.getUTCDate();
    const month = parsedDate.getUTCMonth() + 1;
    const year = parsedDate.getUTCFullYear();

    const hours = parsedDate.getUTCHours();
    const minutes = parsedDate.getUTCMinutes();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${formattedDay}/${formattedMonth}/${year} ${formattedHours}:${formattedMinutes}`;
}